module.exports = __webpack_public_path__ + "static/media/JP.31f9a654.png";